import IBreadcrumb from '@/creditflowresearch/domain/vo/Breadcrumbs';
import { getMarketOverviewBreadcrumbsRoute } from '@/creditflowresearch/ui/common/helpers';
import Product from '@/creditflowresearch/domain/Product';
import Region from '@/creditflowresearch/domain/Region';
import finsightUrl from '@/creditflowresearch/Router/urlConstants';

const getServerSideStatBreadcrumbs = ({ query }, name?: string): IBreadcrumb[] => {
  const {
    products = Product.getDefaultAbbreviation(),
    regions = Region.getDefaultAbbreviation(),
  } = query;
  const commonBreadcrumbs = [
    getMarketOverviewBreadcrumbsRoute(query),
    {
      title: 'Stats',
      url: `${ finsightUrl.CREDIT_FLOW_STATS_LIST_ALL }?products=${
        encodeURI(products)
      }&regions=${
        encodeURI(regions)
      }`,
    },
  ];

  return [
    ...commonBreadcrumbs,
    {
      title: name || 'Stat',
      isActive: true,
    },
  ];
};

export default getServerSideStatBreadcrumbs;
